/* tslint:disable */
/* eslint-disable */
export enum MemberTypes {
  Constructor = 'Constructor',
  Event = 'Event',
  Field = 'Field',
  Method = 'Method',
  Property = 'Property',
  TypeInfo = 'TypeInfo',
  Custom = 'Custom',
  NestedType = 'NestedType',
  All = 'All'
}
